import {
  DesktopSidebarWrapper,
  ListItem,
  NavLinkSplit,
} from '@/pages/CompanyReport/components/Overview/components/DesktopSidebarWithSnowflake/components/DesktopSidebar/components/DesktopSidebar/styled';
import { useTracking } from 'react-tracking';
import { useCompanyReportPageUrl } from '@/pages/CompanyReport/hooks/useCompanyReportPageUrl';
import { useRoutes } from '@/pages/CompanyReport/constants/routes';

import { useCompanyCountryMatch } from '@/pages/StockPage/hooks/useCompanyCountryMatch';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany/useCompanyCanonicalUrl';

interface DesktopSidebarProps {
  selected?: string;
  handleClick?: (section: string) => void;
}

export const DesktopSidebar = ({
  selected,
  handleClick,
}: DesktopSidebarProps) => {
  const { trackEvent } = useTracking();
  const companyUrl = useCompanyReportPageUrl();
  const routes = useRoutes();

  const canonicalUrl = useCompanyCanonicalUrl();

  const { isMatch, stockUrl } = useCompanyCountryMatch(canonicalUrl, 'CA');

  return (
    <DesktopSidebarWrapper>
      <ul>
        {routes.map(({ anchor, label, tracking }, i) => (
          <ListItem key={`${anchor}-${i}`} selected={selected === anchor}>
            <NavLinkSplit
              data-cy-id={`desktop-sidebar-nav-${i}`}
              to={`${companyUrl}${anchor === 'summary' ? '' : `/${anchor}`}`}
              onClick={(e) => {
                // This prevents the link from pushing to window.history
                // we will let the parent handle it via handleClick instead
                e.preventDefault();
                e.stopPropagation();
                anchor && handleClick?.(anchor);
                trackEvent({
                  modifier: tracking || label,
                  type: 'track',
                  action: 'click',
                  subject: 'DesktopSidebar',
                });
              }}
            >
              {i > 0 && i < routes.length - 1 && <label>{i}</label>}
              {label}
            </NavLinkSplit>
          </ListItem>
        ))}
        {isMatch && (
          <ListItem>
            <NavLinkSplit to={stockUrl}>{`View Community`}</NavLinkSplit>
          </ListItem>
        )}
      </ul>
    </DesktopSidebarWrapper>
  );
};
